"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsCreateCustomAudience = exports.facebookAdsCreateCustomAudienceResultSchema = exports.facebookAdsCreateCustomAudienceArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsCreateCustomAudienceArgsSchema = zod_1.z.object({
    name: zod_1.z.string().describe('Custom audience name'),
    subtype: zod_1.z
        .enum(['CUSTOM', 'WEBSITE', 'APP', 'OFFLINE_CONVERSION', 'ENGAGEMENT'])
        .describe('CUSTOM = customer file upload, WEBSITE = pixel-based, APP = app activity, OFFLINE_CONVERSION = offline events, ENGAGEMENT = video/page engagement'),
    description: zod_1.z.string().nullable().optional().describe('Description of the audience'),
    customerFileSource: zod_1.z
        .enum(['USER_PROVIDED_ONLY', 'PARTNER_PROVIDED_ONLY', 'BOTH'])
        .nullable()
        .optional()
        .describe('For CUSTOM subtype: source of customer data'),
    retentionDays: zod_1.z
        .number()
        .min(1)
        .max(180)
        .nullable()
        .optional()
        .describe('For WEBSITE/APP: number of days users stay in audience (1-180)'),
    pixelId: zod_1.z
        .string()
        .nullable()
        .optional()
        .describe('For WEBSITE subtype: Meta Pixel ID to track website visitors. Verify pixel is installed and firing events before creating pixel-based audiences.'),
    rule: zod_1.z
        .string()
        .nullable()
        .optional()
        .describe('For WEBSITE/APP: JSON string of rule spec (e.g., URL contains, event_name equals)'),
    emails: zod_1.z
        .array(zod_1.z.string().email())
        .nullable()
        .optional()
        .describe('For CUSTOM subtype: array of email addresses to add to the audience. Emails will be normalized (lowercased, trimmed) and hashed before upload. Maximum 10,000 emails per request.'),
    emitMode: zod_1.z.literal('single'),
});
exports.facebookAdsCreateCustomAudienceResultSchema = zod_1.z.object({
    id: zod_1.z.string().describe('Created custom audience ID'),
    name: zod_1.z.string().describe('Audience name'),
    delivery_status: zod_1.z
        .object({
        code: zod_1.z.number(),
        description: zod_1.z.string(),
    })
        .describe('Delivery status (200 = ready, 300 = too small, 441 = populating)'),
    users_uploaded: zod_1.z
        .number()
        .nullable()
        .optional()
        .describe('Number of users successfully uploaded (for CUSTOM audiences with emails)'),
    approximate_count: zod_1.z
        .number()
        .nullable()
        .optional()
        .describe('Approximate audience size after upload'),
});
exports.facebookAdsCreateCustomAudience = (0, common_1.createToolMetadata)({
    id: 'facebookAdsCreateCustomAudience',
    displayName: 'Create Meta Custom Audience',
    displayDescription: 'Create a Custom Audience for retargeting (customer lists, website visitors, app users)',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsCreateCustomAudienceArgsSchema,
}, exports.facebookAdsCreateCustomAudienceResultSchema);
